const detailHeaders = [
    { text: '#', value: 'id', sortable: false },
    { text: 'PROD', value: 'id', sortable: false },
    { text: 'CANT', value: 'id', sortable: false },
    { text: 'PREC', value: 'id', sortable: false },
    { text: 'DCTO', value: 'id', sortable: false },
    { text: 'SUBT', value: 'id', sortable: false },
]
const paymentHeaders = [
    { text: 'Tipo', value: 'type' },
    { text: 'Monto', value: 'amount' },
    { text: 'Detalle', value: 'type' },
]
const ticketHeaders = [
    {
        text: 'N° Documento',
        value: 'number',
    },
    {
        text: 'Sucursal',
        value: 'branchOfficeName',
    },
    {
        text: 'Fecha Emisión',
        value: 'emission_date',
    },
    {
        text: 'Vendedor',
        value: 'sellerName',
    },
    {
        text: 'Cajero',
        value: 'cashierName',
    },
    {
        text: 'N° Caja',
        value: 'cashDeskNumber',
    },
    {
        text: 'Total',
        value: 'formattedTotal',
    },
    {
        text: 'Acciones',
        value: 'slot',
    },
]
const invoiceHeaders = [
    {
        text: 'N° Documento',
        value: 'number',
    },
    {
        text: 'Fecha Emisión',
        value: 'emission_date',
    },
    {
        text: 'Sucursal',
        value: 'branchOfficeName',
    },
    {
        text: 'Cliente',
        value: 'customerName',
    },
    {
        text: 'RUT Cli.',
        value: 'customerRutFormatted',
    },
    {
        text: 'Suc. Cliente',
        value: 'customerOfficeText',
    },
    {
        text: 'Vendedor',
        value: 'sellerName',
    },
    {
        text: 'Cajero',
        value: 'cashierName',
    },
    {
        text: 'N° Caja',
        value: 'cashDeskNumber',
    },
    {
        text: 'Neto',
        value: 'formattedNet',
    },
    {
        text: 'IVA',
        value: 'formattedIva',
    },
    {
        text: 'Total',
        value: 'formattedTotal',
    },
    {
        text: 'Acciones',
        value: 'slot',
    },
]
const creditNoteHeaders = [
    {
        text: 'N° Documento',
        value: 'number',
    },
    {
        text: 'Fecha Emisión',
        value: 'emission_date',
    },
    {
        text: 'Tipo',
        value: 'affectedDocTypeName',
    },
    {
        text: 'Cliente',
        value: 'customerName',
    },
    {
        text: 'Suc. Cliente',
        value: 'customerOfficeText',
    },
    {
        text: 'N° Doc Anulado',
        value: 'affectedDocNumber',
    },
    {
        text: 'Total',
        value: 'formattedTotal',
    },
    {
        text: 'Acciones',
        value: 'slot',
    },
]
export {
    detailHeaders,
    ticketHeaders,
    creditNoteHeaders,
    invoiceHeaders,
    paymentHeaders,
}
